<template>
  <div class="tags">
    <div class="title t-h3" v-text="t('tags')" />
    <ArticleTag
      v-for="tag in tags"
      :key="tag.id"
      :text="tag.name"
      :selected="isSelected(tag.id)"
      :link="getLink(tag.id)"
    />
    <ArticleTag
      v-if="filters.areFiltersActive.value"
      :text="t('clear-all-filters')"
      :link="filters.clearSelectedTagsLink.value"
      :selected="filters.areFiltersActive.value"
      clear
    />
  </div>
</template>

<script lang="ts" setup>
import type { ArticleFilters } from '@/composables/useArticleFilters'
import type { PublicTag } from '@/service/__generated-api'

const props = defineProps<{
  tags: PublicTag[]
  filters: ArticleFilters
}>()

const isSelected = (tagId: string) =>
  props.filters.selectedTags.value.includes(tagId)

const getLink = (tagId: string) =>
  isSelected(tagId)
    ? props.filters.getRemoveTagLink(tagId)
    : props.filters.getSelectTagLink(tagId)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: rem(12px);
  margin-bottom: rem(52px);
}

.title {
  width: 100%;
  margin-bottom: rem(20px);
}
</style>
